//Consumer Routes
export const myRequestRoute = "/my-request/power-applications";
export const myOtherRequestRoute = "/my-request/other-applications";
export const myFireSafetyRequestRoute = "/my-request/building-information";

export const profileRoute = "/profile";
export const consumerDashboardRoute = "/dashboard";
export const consumerBillsRoute = "/my-bills";
export const consumerComplaintRoute = "/my-complaints";
export const consumerPaymentHistoryRoute = "/payment-history";
export const consumerPaymentRoute = "/payment";
export const consumerDebitNoteRoute = "/my-debit-note";
export const consumerCreditNoteRoute = "/my-credit-note";
export const consumerUtilityConsumersRoute = "/utility-consumers";
export const fireRegisterBuildingRoute = "/fire-safety/register-building";

// Power Application Routes
export const permanentRoute = "/power-application-form/permanent-connection";
export const temporaryRoute = "/power-application-form/temporary-connection";
export const nameTransferRoute = "/power-application-form/name-transfer";
export const demandReductionRoute =
  "/power-application-form/demandAlteration/demand-reduction";
export const demandExtensionRoute =
  "/power-application-form/demandAlteration/demand-extension";
export const premiseAmalgamationRoute =
  "/power-application-form/premise-amalgamation";
export const premiseRemovalRoute = "/power-application-form/premise-removal";
export const shiftingOfServiceRoute =
  "/power-application-form/shifting-of-service";
export const changeOfCategoryRoute =
  "/power-application-form/change-of-category";
export const netMeteringRoute = "/power-application-form/net-metering";
export const backupPowerRoute = "/power-application-form/backup-power";
export const removalOfConnectionRoute =
  "/power-application-form/removal-of-connection";
export const cgrfGiftPclRoute = "/cgrf";

// Other Applications Routes

export const otherUtilitiesPermanentRoute =
  "/other-application-form/permanent-connection";
export const otherUtilitiesTemporaryRoute =
  "/other-application-form/temporary-connection";

export const otherUtilitiesDemandReductionRoute =
  "/other-application-form/demandAlteration/demand-reduction";
export const otherUtilitiesDemandExtensionRoute =
  "/other-application-form/demandAlteration/demand-extension";

export const otherUtilitiesNameChangeRoute =
  "/other-application-form/name-transfer";
export const otherUtilitiesRemovalOfConnectionRoute =
  "/other-application-form/removal-of-connection";

//Admin Routes

export const adminDashboardRoute = "/admin/dashboard";
export const adminPowerApplicationRequestsRoute =
  "/admin/applications/power-applications";
export const adminOtherApplicationRequestsRoute =
  "/admin/applications/other-applications";

export const adminUtilityConsumerRoute = "/admin/utility-consumers";
export const userManagement = "/admin/users/user-management";
export const approverManagement = "/admin/users/approver-management";
export const adminAuthorizedUsers = "/admin/users/authorized-users";
export const adminMasterDataRoute = "/admin/master-data";
export const adminComplaintRoute = "/admin/complaints";
export const adminBillingCycleRoute = "/admin/billing/billingCycle";
export const adminMeterReadingRoute = "/admin/power-billing/meter-reading";
export const adminBillingCalculationReportRoute =
  "/admin/power-billing/billing-calculation";

export const adminBillCalculationsDataRoute =
  "/admin/billing/bill-calculations";
export const adminUnpaidBillsRoute = "/admin/billing/unpaid-bills";
export const adminPaymentHistoryRoute = "/admin/payment/payment-history";
export const adminPaymentDebitNoteRoute = "/admin/payment/debit-note";
export const adminPaymentCreditNoteRoute = "/admin/payment/credit-note";
export const adminOutstandingReportRoute = "/admin/payment/outstanding-report";
export const adminOutstandingInvoiceRoute =
  "/admin/payment/outStanding-invoice";

export const adminReportsRoute = "/admin/reports";
export const adminUserDocumentsRoute = "/admin/user-documents";
export const adminTechnicalSanctionDocumentsRoute =
  "/admin/technical-sanction/documents";
export const adminDemandEstimateDocumentsRoute =
  "/admin/demand-estimate/documents";
export const adminSecurityDepositRoute =
  "/admin/power-billing/security-deposit";
export const adminBillingBackupPowerRoute = "/admin/power-billing/backup-power";
export const adminBillingDailyMeterReadingsReportRoute =
  "/admin/power-billing/daily-meter-reading";
export const adminBillingUserBillsRoute = "/admin/billing/user-bills";
export const adminOtherBillingMeterReadingRoute =
  "/admin/other-utility-billing/meter-reading";
export const adminOtherBillingCalculationReportRoute =
  "/admin/other-utility-billing/billing-calculation";
export const adminOtherBillingInvoiceReportRoute =
  "/admin/other-utility-billing/dcs-additional-report";
export const adminDcsAdditionalRoute =
  "/admin/other-utility-billing/e-invoice-report";
export const adminOtherMonthlyBillingReport =
  "/admin/other-utility-billing/monthly-billing-report";

export const adminHomePageDocumentRoute = "/admin/homepagecontent/document";
export const adminHomePageContentRoute = "/admin/homepagecontent/content";
export const adminTemporaryDisconnectedConsumerRoute =
  "/admin/temporary-disconnected-consumers";
export const adminDispatchedBillRoute = "/admin/billing/dispatched-bills";
export const adminPowerAbstractRoute = "/admin/power-billing/power-abstract";
export const adminPowerOutstandingNoticeRoute =
  "/admin/billing/outstanding-notice";
export const adminPowerMissingReadingsRoute = "/admin/billing/missing-readings";
export const adminActivityLogRoute = "/admin/event-logs";
export const adminOfflinePaymentRoute = "/admin/payment/offline-bill-payment";

//Public Routes

export const homeRoute = "/";
export const paymentRoute = "/make-payment";
export const giftInfo = "/gift-info";
export const energyCalculator = "/energy-calculator";
export const waysToSaveMonet = "/simple-ways-to-save-money";
export const quickPaymentRoute = "/quick-payment";

// Fire safety

export const fireSafetyHomeRoute = "/fire-safety";
export const fireSafetyProfileRoute = "fire-safety/profile";
export const fireSafetyConsumerDashboardRoute =
  "/fire-safety/consumer/dashboard";
export const fireSafetyAdminDashboardRoute = "/fire-safety/admin/dashboard";
export const fireSafetyCalenderRoute = "/fire-safety/admin/calendar";
export const fireSafetyUserManagementRoute =
  "/fire-safety/admin/user-management";
export const fireSafetyMyRequestRoute =
  "/fire-safety/my-request/building-applications";
export const fireSafetyAdminBuildingApplicationsRoute =
  "/fire-safety/admin/building-information";
export const fireSafetyAdminBuildingObservationRoute =
  "/fire-safety/admin/building-observation";
export const fireSafetyAdminReportsRoute = "/fire-safety/admin/reports";
export const fireMockDrillRoute = "/fire-safety/mock-drill";
export const fireNocRoute = "/fire-safety/fire-noc";

// Utility Tunnel
export const utilityTunnelHomeRoute = "/utility-tunnel";
export const utilityTunnelAdminDashboardRoute =
  "/utility-tunnel/admin/dashboard";
export const utilityTunnelConsumerDashboardRoute =
  "/utility-tunnel/consumer/dashboard";
export const utilityTunnelUserManagementRoute =
  "/utility-tunnel/admin/user-management";
export const utilityTunnelAccessApplicationRoute =
  "/utility-tunnel/access-details/application";
export const utilityTunnelMyRequestApplicationRoute =
  "/utility-tunnel/my-request/access-application";
export const utilityTunnelProfileRoute = "/utility-tunnel/profile";
